<template>
    <arki-project-component
        :request-id="requestId"
    />
</template>

<script>
import ArkiProjectComponent from '@/views/arki/views/request/project/arki-project-component.vue';
export default {
    name: 'arki-request-card-view',
    components: { ArkiProjectComponent },
};
</script>

<script setup>
import { onBeforeMount, ref } from 'vue';
import { useRoute } from 'vue-router';

const
    route = useRoute(),
    requestId = ref();

onBeforeMount(async () => {
    requestId.value = route.params.requestId;
});

</script>

<style scoped>

</style>
